var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddToContacts = function SvgAddToContacts(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-20": 18,
    "data-width-24": 21,
    viewBox: "0 0 13.7 13.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.867 6.333a3.167 3.167 0 1 1 0-6.333 3.167 3.167 0 0 1 0 6.333m0-5.333a2.167 2.167 0 1 0 2.167 2.167A2.173 2.173 0 0 0 5.867 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M10.7 8.167v2.5m0 2.5v-2.5m2.5 0h-2.5m-2.5 0h2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.033 8.333S7.033 8 5.833 8C1.567 8 .5 11.111.5 12.667h7.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddToContacts);
export default ForwardRef;